import React, { useState, useEffect } from "react";
import { SearchParameters } from "../../model/SearchParameters";

interface Filter {
  id: string;
  name: string;
  rootCategoryName: string;
}
const FilterComponent = ({
  allFilters,
  component_name,
  componentTypeKey,
  selectedFilter,
  setSelectedFilter,
  lastSelectedFilter,
}: {
  allFilters: SearchFilterItem[];
  component_name: string;
  componentTypeKey: keyof SearchParameters;
  selectedFilter: string | null;
  setSelectedFilter: (value: string) => void;
  lastSelectedFilter: string | null;
}) => {
  const groupFiltersByCategory = (allFilters: SearchFilterItem[]) => {
    return allFilters.reduce(
      (acc, filter) => {
        if (!acc[filter.brand]) {
          acc[filter.brand] = [];
        }
        acc[filter.brand].push(filter);
        return acc;
      },
      {} as Record<string, SearchFilterItem[]>,
    );
  };

  const groupedFilters = groupFiltersByCategory(allFilters);

  return (
    <div className="field mt-4">
      <label className="label">{component_name}</label>
      <div className="control">
        <div className="select is-fullwidth">
          <select
            value={selectedFilter || ""}
            onChange={(e) => {
              const selectedId = e.target.value as string;
              setSelectedFilter(selectedId);
            }}
          >
            <option value="">Todos</option>
            {Object.entries(groupedFilters).map(([type, filters]) =>
              filters.map((filter, index) => {
                if (
                  lastSelectedFilter != null &&
                  ((lastSelectedFilter != componentTypeKey &&
                    filter.count_filter_compounds === 0) ||
                    (lastSelectedFilter == componentTypeKey &&
                      filter.count_skipped_compounds === 0)) &&
                  selectedFilter != filter.name
                ) {
                  return null;
                }
                return (
                  filter.name !== "" && (
                    <option key={index} value={filter.name}>
                      {filter.name}
                    </option>
                  )
                );
              }),
            )}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterComponent;
